import { Fragment, useEffect, useRef, useState } from "react";
import Loader from "react-loader-spinner";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, Card, Form, FormGroup, OverlayTrigger, Popover, Row, Table } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import { getComplaintBaseInfoes, getComplaintsSubGroup, addEditComplaint, getComplaint, closeComplaint } from "../store/api/ComplaintsAPI";
import { Calendar2DateFill, Check2Circle, CheckLg, Link45deg, List, PencilFill, PersonPlusFill, Reply, Save, Search, Tools, Trash } from "react-bootstrap-icons";
import ModalProducts from "../../Components/Modals/ModalProducts";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import { keyIsLetterOrNumber, setErrorDialog, getAttachmentList, deleteAttachment, downloadFile, attachFile, getSettingValue, getSettingNumberValue } from "../../store/api/CommonFunctions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngry, faList } from "@fortawesome/free-solid-svg-icons";
import ModalSelectCustomer from "../../Components/Modals/ModalSelectCustomer";
import { getServiceSummaryList, getServiceSummary } from "../store/api/ServiceAPI";
import { useParams } from "react-router-dom";
import ModalReferDocument from "../Components/ModalReferDocument";
import { setReferDocPop } from "../store/api/Users";
const Complaint = () => {
    const { compID, serviceID, serviceType } = useParams();
    const dispatch = useDispatch();
    const [isPending, setPending] = useState(false);
    const history = useHistory();
    const complaintAttachment = useRef();
    const complaintCloseData = useRef({});
    const [attachList, setAttachList] = useState(null);
    const [complaintData, setComplaintData] = useState({});
    const [modalProducts, setModalProducts] = useState({ show: false });
    const [modalCustomer, setModalCustomer] = useState({ show: false });
    const [customerServices, setCustomerServices] = useState(null);
    const [baseInfoes, setBaseInfoes] = useState(null);
    const [subGroups, setSubGroups] = useState(null);
    const settingNames = ["ProductGrouppingType"];
    const { systemSettings } = useSelector(state => { return { systemSettings: state.SystemSettingsReducer.systemSettings } });
    const pgType = getSettingNumberValue(systemSettings, "ProductGrouppingType", "1");
    const { register, handleSubmit, errors } = useForm();
    function loadSubGroups(mainGroupID) {
        getComplaintsSubGroup(mainGroupID, setSubGroups);
    }
    function attachNewFile(id) {
        let f = complaintAttachment.current?.files;
        const onSuccess = () => {
            if (Number(id) > 0)
                history.replace(`/CRM/Complaint/${id}/0/0`);
            setPending(false);
        }
        if (f?.length > 0) {
            dispatch(attachFile(complaintAttachment.current, id, "ComplaintsAttachment", onSuccess));
        }
        else {
            onSuccess();
        }
    }
    function getAttachList() {
        if (attachList === null) {
            getAttachmentList(compID, "ComplaintsAttachment", setAttachList);
        }
    }
    function onSubmit(data) {
        if ((data.RelatedServiceTypeAndID ?? "").length > 0) {
            data.RelatedServiceID = data.RelatedServiceTypeAndID.split('/')[1];
            data.RelatedServiceType = data.RelatedServiceTypeAndID.split('/')[0].toLowerCase();
        }
        data.ID = compID;
        setPending(true);
        dispatch(addEditComplaint(data, attachNewFile));
    };
    function showModalProducts(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelectProduct = (p) => {
            if (p) {
                setComplaintData({ ...complaintData, ProductName: p.ProductName, ProductModel: p.ProductModel, ProductID: p.ProductID });
            }
        }

        setModalProducts({
            show: true,
            value: e?.key,
            setProductData: onSelectProduct
        })
    }
    function showModalCustomer(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const setData = (data) => {
            if (data?.ID) {
                setComplaintData({ ...complaintData, RelatedCustomerID: data.ID, CustomerName: data.Name, CustomerTel: data.Phone, CustomerMobile: data.Mobile });
                getServiceList(data.ID);
            }
        }
        setModalCustomer({
            show: true,
            setCustomerData: setData
        })
    }
    function getServiceList(customerID, serial) {
        if (!customerID) {
            return;
        }
        const onGet = (res) => {
            if (res.Data) {
                setCustomerServices(res.Data)
            }
            else if (res === "PENDING") {
                setCustomerServices("PENDING");
            }
        }
        getServiceSummaryList(customerID, serial ?? "", onGet);
    }
    function onSelectServiceTypeAndID(e) {
        const si = e.target.value;
        if (si === "") {
            setComplaintData({ ...complaintData, ProductName: null, ProductModel: null, ProductID: null, ProductSerial: null, FromService: false });
            return;
        }
        const serviceType = si.split("/")[0];
        const serviceID = Number(si.split("/")[1]);
        const cs = customerServices.find(s => s.ServiceType === serviceType && Number(s.ServiceID) === serviceID);
        setComplaintData({ ...complaintData, ProductID: cs.ProductID, ProductName: cs.ProductName, ProductModel: cs.ProductModel, ProductSerial: cs.ProductSerial, FromService: true });
    }
    function onSerialChanged(e) {
        setComplaintData({ ...complaintData, ProductSerial: e.target.value });
    }
    function showDocRefer() {
        dispatch(setReferDocPop({ show: true, documentHardCode: "complaint", documentID: compID }));
    }
    function closeComp() {
        const onCloseComp = (res) => {
            const msg = res.Error ?? res;
            setErrorDialog(dispatch, msg, "فرجام شکایت");
        }
        closeComplaint(
            complaintCloseData.current.CloseDesc ?? complaintData.CloseDescription,
            compID,
            complaintCloseData.current.SatisfactionAfterClose ?? complaintData.CustomerSatisfactionAfterClose,
            onCloseComp)
    }
    function gotoService() {
        window.open(`/Services/Service/${complaintData.RelatedServiceID}/${complaintData.RelatedServiceType}`);
    }
    function delAttach(id) {
        setAttachList("PENDING");
        dispatch(deleteAttachment(id, () => getAttachmentList(compID, "ComplaintsAttachment", setAttachList)));
    }
    function onAttacheChanged(e) {
        setAttachList("PENDING");
        const onDone = (res) => {
            e.target.value = "";
            getAttachmentList(compID, "ComplaintsAttachment", setAttachList);
        }
        dispatch(attachFile(e.target, compID, "ComplaintsAttachment", onDone));
    }
    const popCloseComplaint = (
        <Popover id="popCloseComplaint" style={{ fontFamily: "Vazir", fontSize: "12px", minWidth: "300px" }}>
            <Popover.Title className="headerStyle">
                فرجام شکایت
            </Popover.Title>
            <Popover.Content className="bodyStyle">
                {complaintData.IsClosed &&
                    <Fragment>
                        <label className="mb-1" style={{ color: "blue" }}>تاریخ فرجام: {complaintData?.PCloseDate}</label>
                        <label className="mb-1" style={{ color: "blue", float: "left" }}>ثبت کننده: {complaintData?.CloseByName}</label>
                    </Fragment>
                }
                <FormGroup>
                    <label>میزان رضایت پس از فرجام(درصد)‏</label>
                    <Form.Control style={{ width: "70%" }} type="number" defaultValue={complaintData?.CustomerSatisfactionAfterClose ?? ""}
                        onChange={e => complaintCloseData.current.SatisfactionAfterClose = e.target.value} />
                </FormGroup>
                <FormGroup>
                    <label>شرح فرجام: </label>
                    <Form.Control defaultValue={complaintData?.CloseDescription ?? ""} onChange={e => complaintCloseData.current.CloseDesc = e.target.value} />
                </FormGroup>
                <Button className="group-Btn mt-1" variant="success" onClick={closeComp} disabled={complaintData?.IsClosed ?? false}><CheckLg size={15} />&nbsp; ثبت فرجام</Button>
            </Popover.Content>
        </Popover>
    )
    const popAttachments = (
        <Popover style={{ fontFamily: "Vazir", maxWidth: "450px", minWidth: "450px" }}>
            <Popover.Title className="headerStyle">
                <FontAwesomeIcon icon={faList} />&nbsp; پیوست ها
            </Popover.Title>
            <Popover.Content className="bodyStyle">
                <FormGroup>
                    <input type="file" className="form-control" onChange={onAttacheChanged} />
                </FormGroup>
                <Table responsive className="fixedTable mt-1" style={{ whiteSpace: "nowrap" }}>
                    <thead>
                        <tr>
                            <th style={{ width: "50%" }}>نام فایل</th>
                            <th style={{ width: "30%" }}>تاریخ پیوست</th>
                            <th style={{ width: "20%" }}>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(attachList ?? "") &&
                            attachList.map((atc, i) =>
                                <tr key={i} className="resultTableRow">
                                    <td style={{ width: "50%", overflow: "hidden" }}>{atc.AttachFileName}</td>
                                    <td style={{ width: "30%" }}>{atc.PAttachDate}</td>
                                    <td style={{ width: "20%" }}>
                                        <Save size={18} color="blue" className="rowBtn" onClick={() => downloadFile(atc.ID, "ComplaintsAttachment")} />&nbsp;
                                        <Trash size={18} color="red" className="rowBtn" onClick={() => delAttach(atc.ID)} />
                                    </td>
                                </tr>)
                        }
                    </tbody>

                </Table>
            </Popover.Content>
        </Popover>
    )
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-مشتریان";
        dispatch(getSystemSettings(settingNames));
        getComplaintBaseInfoes(setBaseInfoes);
        setCustomerServices(null);
        setSubGroups(null);
    }, [])
    useEffect(() => {

        if (Number(compID) > 0) {
            const onGetComp = (res) => {
                if (res.Data) {
                    res.Data.RelatedServiceTypeAndID = res.Data.RelatedServiceType + "/" + res.Data.RelatedServiceID;
                    getServiceList(res.Data.RelatedCustomerID, res.Data.ProductSerial);
                    setComplaintData(res.Data);
                    getComplaintsSubGroup(res.Data.MainGroupID, setSubGroups);
                }
                else if (res === "PENDING") {
                    setComplaintData("PENDING");
                }
            }
            getComplaint(compID, onGetComp)
        }
        else if (Object.keys(complaintData).length > 0) {
            setComplaintData({});
        }
    }, [compID]);
    useEffect(() => {
        if (Number(serviceID) > 0) {
            const onGet = (res) => {
                if (res.Data) {
                    res.Data.RelatedServiceTypeAndID = `${serviceType}/${serviceID}`;
                    const data = res.Data;
                    const pServiceType = serviceType?.toLowerCase() === "repair" ? "تعمیر" : "نصب";
                    setCustomerServices([{
                        ServiceTypeAndID: data.RelatedServiceTypeAndID,
                        PServiceType: pServiceType,
                        ServiceNumber: data.InvoiceNumber
                    }])
                    setComplaintData({
                        ...data,
                        CusotmerTel: data.CustomerPhone,
                        RelatedCustomerID: data.CustomerID,
                        FromService: true
                    })
                }
                else if (res === "PENDING") {
                    setComplaintData("PENDING");
                }
            }
            getServiceSummary(serviceType, serviceID, onGet);
        }
    }, [serviceType, serviceID])
    return (
        <div className="container-fluid mt-1">
            <Card>
                <ModalProducts popData={modalProducts} setProductPopup={setModalProducts} productGrouppingType={pgType} />
                <ModalSelectCustomer popData={modalCustomer} setCustomerPopup={setModalCustomer} />
                <ModalReferDocument />
                <Card.Header className="headerStyle"><FontAwesomeIcon icon={faAngry} size="lg" />&nbsp; ثبت شکایت</Card.Header>
                <Card.Body className="bodyStyle">
                    {
                        complaintData === "PENDING" &&
                        <div style={{ width: "100%", textAlign: "center" }}> <Loader type="BallTriangle" color="#bb1370" width={25} height={25} /></div>
                    }
                    {
                        complaintData !== "PENDING" &&

                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Row>
                                <FormGroup className="col-md-2">
                                    <label>مشخصات مشتری</label><span className="errors">*</span>
                                    <input type="hidden" readOnly value={complaintData?.RelatedCustomerID ?? ""} name="RelatedCustomerID" ref={register({})} />
                                    <Form.Control readOnly value={complaintData?.CustomerName ?? ""} onKeyDown={showModalCustomer} ref={register({})} name="CustomerName" />
                                    <Button className="btn-input-tiny" onClick={showModalCustomer} style={{ top: 26 }}><List size={21} /></Button>
                                    {errors?.RelatedCustomerID && <small className="errors">انتخاب مشتری الزامی است</small>}
                                </FormGroup>
                                <FormGroup className="col-md-2">
                                    <label>شماره تلفن مشتری</label>
                                    <Form.Control readOnly value={complaintData?.CustomerTel ?? ""} name="CustomerTel" ref={register({})} />
                                </FormGroup>
                                <FormGroup className="col-md-2">
                                    <label>شماره همراه مشتری</label>
                                    <Form.Control readOnly value={complaintData?.CustomerMobile ?? ""} name="CustomerMobile" ref={register({})} />
                                </FormGroup>
                                <FormGroup className="col-md-2">
                                    <label>گروه اصلی شکایت </label>
                                    {!Array.isArray(baseInfoes?.MainGroupList ?? "") &&
                                        <div className="form-control">
                                            <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;
                                            در حال بارگذاری اطلاعات
                                        </div>
                                    }
                                    {Array.isArray(baseInfoes?.MainGroupList ?? "") &&
                                        <select className="form-control" onChange={e => loadSubGroups(e.target.value)} defaultValue={complaintData?.MainGroupID ?? ""}>
                                            <option>انتخاب کنید</option>
                                            {baseInfoes.MainGroupList.map((item, i) =>
                                                <option key={i} value={item.MainGroupID}> {item.MainGroupName}</option>
                                            )}
                                        </select>
                                    }
                                </FormGroup>
                                <FormGroup className="col-md-2">
                                    <label>گروه فرعی شکایت </label>
                                    {subGroups === "PENDING" &&
                                        <div className="form-control">
                                            <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;
                                            در حال بارگذاری اطلاعات
                                        </div>
                                    }
                                    {subGroups !== "PENDING" &&
                                        <select className="form-control" name="GroupID" ref={register({})} defaultValue={complaintData?.GroupID ?? ""}>
                                            <option>انتخاب کنید</option>
                                            {Array.isArray(subGroups?.Data ?? "") && subGroups.Data.map((item, i) => {
                                                return (
                                                    <option key={i} value={item.GroupID}> {item.GroupName}</option>
                                                )
                                            })}
                                        </select>
                                    }
                                </FormGroup>
                                <FormGroup className="col-md-2">
                                    <label>بخش مورد شکایت</label>
                                    {baseInfoes === "PENDING" &&
                                        <div className="form-control">
                                            <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;
                                            در حال بارگذاری اطلاعات
                                        </div>
                                    }
                                    {baseInfoes !== "PENDING" &&
                                        <select className="form-control" name="TargetID" ref={register({})} defaultValue={complaintData?.TargetID ?? ""}>
                                            <option>انتخاب کنید</option>
                                            {Array.isArray(baseInfoes?.TargetList ?? "") && baseInfoes.TargetList.map((item, i) => {
                                                return (
                                                    <option key={i} value={item.ID}> {item.Target}</option>
                                                )
                                            })}
                                        </select>
                                    }
                                </FormGroup>
                                <FormGroup className="col-md-2">
                                    <label>نوع و شماره سرویس</label>
                                    {customerServices === "PENDING" &&
                                        <div className="form-control">
                                            <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;
                                            در حال بارگذاری اطلاعات
                                        </div>
                                    }
                                    {customerServices !== "PENDING" &&
                                        <Form.Control as="select" name="RelatedServiceTypeAndID" ref={register({})} onChange={onSelectServiceTypeAndID} defaultValue={complaintData?.RelatedServiceTypeAndID ?? ""}>
                                            <option value="">انتخاب کنید</option>
                                            {Array.isArray(customerServices ?? "") && customerServices.map((cs, i) => <option key={i} value={cs.ServiceTypeAndID}>{cs.PServiceType + " شماره " + cs.ServiceNumber}</option>)}
                                        </Form.Control>
                                    }
                                </FormGroup>
                                <FormGroup className="col-md-3">
                                    <label>مشخصات محصول</label>
                                    <input type="hidden" name="ProductID" ref={register({})} readOnly value={complaintData?.ProductID ?? ""} />
                                    <Form.Control onKeyDown={showModalProducts} readOnly value={(complaintData?.HolderName ? complaintData.HolderName + "-" : "") + (complaintData?.ProductName ? complaintData.ProductName + '-' : "") + (complaintData?.ProductModel ?? "")} />
                                    <Button className="btn-input-tiny" style={{ top: 26 }} onClick={showModalProducts} disabled={complaintData?.FromService ?? false}><List size={21} /></Button>
                                </FormGroup>
                                <FormGroup className="col-md-3">
                                    <label>سریال محصول</label>
                                    <input type='text' className="form-control" name="ProductSerial" ref={register({})} value={complaintData?.ProductSerial ?? ""} onChange={onSerialChanged} readOnly={complaintData?.FromService ?? false} />
                                    <Button className="btn-input-tiny" onClick={() => getServiceList(complaintData?.RelatedCustomerID, complaintData?.ProductSerial)} style={{ top: 26 }} disabled={complaintData?.FromService ?? false}><Search size={21} /></Button>
                                    {errors.ProductSerial && <small className="errors"> شماره سریال را وارد کنید </small>}
                                </FormGroup>
                                <FormGroup className="col-md-2">
                                    <label>اولویت</label>
                                    <input type="number" className="form-control" name="Priority" defaultValue={complaintData?.Priority ?? 3} ref={register({})} />
                                </FormGroup>
                                <FormGroup className="col-md-2">
                                    <label>مهلت پاسخگویی(روز)</label>
                                    <input type="number" className="form-control" name="DeadlineInDays" defaultValue={complaintData?.DeadlineInDays ?? 5} ref={register({})} />
                                </FormGroup>
                                <FormGroup className="col-md-2">
                                    <label>وضعیت شکایت</label>
                                    {!Array.isArray(baseInfoes?.StatusList ?? "") &&
                                        <div className="form-control">
                                            <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;
                                            در حال بارگذاری اطلاعات
                                        </div>
                                    }
                                    {Array.isArray(baseInfoes?.StatusList ?? "") &&
                                        <select className="form-control" name="StatusID" ref={register({})} defaultValue={complaintData?.StatusID ?? ""}>
                                            <option value="">انتخاب کنید</option>
                                            {
                                                baseInfoes.StatusList.map((item, i) => <option key={i} value={item.ID}>{item.Status}</option>)
                                            }
                                        </select>
                                    }
                                </FormGroup>
                                <FormGroup className="col-md-2">
                                    <label className="ellipsisLabel" title="میران تاثیر بر وجهه سازمان">میزان تاثیر بر وجهه سازمان</label>
                                    {
                                        <select className="form-control" defaultValue={complaintData?.Influence ?? 2} name="Influence" ref={register({})}>
                                            <option value={0}>بالا</option>
                                            <option value={1}>متوسط</option>
                                            <option value={2}>پایین</option>
                                        </select>
                                    }
                                </FormGroup>
                                <FormGroup className="col-md-2">
                                    <label>نوع شاکی</label>
                                    {!Array.isArray(baseInfoes?.TypeList ?? "") &&
                                        <div className="form-control">
                                            <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;
                                            در حال بارگذاری اطلاعات
                                        </div>
                                    }
                                    {Array.isArray(baseInfoes?.TypeList ?? "") &&
                                        <select className="form-control" name="ComplaintTypeID" ref={register({})} defaultValue={complaintData?.ComplaintTypeID ?? ""}>
                                            <option value="">انتخاب کنید</option>
                                            {
                                                baseInfoes.TypeList.map((item, i) => <option key={i} value={item.TypeID}>{item.TypeName}</option>)
                                            }
                                        </select>
                                    }
                                </FormGroup>
                                {Number(compID) === 0 &&
                                    <FormGroup className="col-md-3">
                                        <label>پیوست</label>
                                        <input className="form-control" style={{ fontSize: "13px" }} type="file" ref={complaintAttachment} />
                                    </FormGroup>
                                }
                            </Row>
                            <Row className="rowBorder mt-2">
                                <FormGroup className="col-md-3">
                                    <label>عنوان شکایت</label><span style={{ color: "red" }}>*</span>
                                    <input type="text" className="form-control" name="Title" ref={register({ required: true })} defaultValue={complaintData?.Title ?? ""} />
                                    {errors.Title && <small className="errors"> عنوان شکایت را وارد کنید </small>}
                                </FormGroup>
                                <FormGroup>
                                    <label>متن شکایت</label><span style={{ color: "red" }}>*</span>
                                    <Form.Control as="textarea" name="Body" ref={register({ required: true })} defaultValue={complaintData?.Body ?? ""} />
                                    {errors.Body && <small className="errors"> متن شکایت را وارد کنید </small>}
                                </FormGroup>
                            </Row>

                            <Button variant="success" className="group-Btn-large mt-2" type="submit" disabled={isPending}>
                                {isPending && <Loader type="Watch" color="white" height={17} width={17} style={{ display: "inline-block" }} />}
                                {!isPending && Number(compID) === 0 && <Fragment><CheckLg size={17} />&nbsp;ثبت شکایت</Fragment>}
                                {!isPending && Number(compID) > 0 && <Fragment><PencilFill size={14} />&nbsp;ویرایش شکایت</Fragment>}
                            </Button>
                            {Number(compID) > 0 &&
                                <Fragment>
                                    <Button variant="secondary" className="group-Btn-large mt-2" onClick={showDocRefer}>
                                        <Reply size={17} />&nbsp;ارجاع به کاربر
                                    </Button>
                                    <OverlayTrigger overlay={popCloseComplaint} trigger="click">
                                        <Button variant="info" className="group-Btn-large mt-2"><Check2Circle size={18} />&nbsp;فرجام شکایت</Button>
                                    </OverlayTrigger>
                                    <OverlayTrigger overlay={popAttachments} trigger="click">
                                        <Button className="btn-violet group-Btn-large mt-2" onClick={getAttachList}><Link45deg size={19} />&nbsp;پیوست ها</Button>
                                    </OverlayTrigger>
                                </Fragment>
                            }
                            {
                                Number(complaintData?.RelatedServiceID ?? 0) > 0 &&
                                <Button className="group-Btn-large mt-2" onClick={gotoService}><Tools size={16} />&nbsp;سرویس مرتبط</Button>
                            }
                            <div style={{ position: "absolute", left: "5px", maxWidth: "200px", width: "fit-content", bottom: "5px", color: "blue", fontSize: "9px", textAlign: "right" }}>
                                {
                                    complaintData.PCreationDate !== undefined && complaintData.PCreationDate.length > 0 &&
                                    <div>
                                        &nbsp;<Calendar2DateFill size={12} color="#2894b1" /><label>&nbsp;تاریخ ثبت: <label style={{ direction: "ltr" }}>{complaintData.PCreationDate}</label></label>
                                    </div>
                                }
                                {complaintData.CreateByName?.length > 0 &&
                                    <div >
                                        <PersonPlusFill size={15} color="#ff5e00" /><label>&nbsp;ثبت کننده: {complaintData.CreateByName}</label>
                                    </div>
                                }
                            </div>
                        </form>
                    }
                </Card.Body>

            </Card>
        </div>
    );
}
export default Complaint;